<template>
  <div class="sdiv sdiv1 cpointer"  @click="goDetail(tourl)">
    <div class="fs18" v-html="title"></div>
    <div class="tc9 lh18 mt15 int ofhidden" v-html="msg">
    </div>
    <router-link :to="tourl" class="cgreen mt10 dinline-block" target="_blank">{{url}}</router-link>
    <div class="tright cblue mt10">
      <span>日期： {{item.release_time}}</span>
      <span>来源： {{item.theme_name}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "search-item",
  data(){
    return {
      title:'',
      msg:'',
      url:'',
      tourl:'',
    }
  },
  props:[
    'item',
    'keyword',
  ],
  methods:{
    dealMsg(){
      var len = 300
      this.msg = this.msg.replace(/<.*?>|\&.*\;/ig, "");
      //this.msg = this.msg.replace(/<[^>]*>/g, "");
      var index_ = this.msg.indexOf(this.keyword);
      //console.log(index_)
      if(index_ > 0){
        // if(index_ > 300)
        //   this.msg = this.msg.substr(index_- 200, index_ + 100)
        // else
        //   this.msg = this.msg.substr(0, len)
        //之前有问题 先备注
        var newStr =  this.msg.substr(0,index_)
        var lastD = newStr.lastIndexOf('，')
        var lastJ = newStr.lastIndexOf('。')
        var last = (lastD>lastJ)?lastD:lastJ
        if(last > 0){
          //this.msg = this.msg.substr(last+1,this.msg.length);
          this.msg = this.msg.substr(last+1, len)
        }else
          this.msg = newStr.substr(index_ - 300, len)
        
      }else{
        this.msg = this.msg.substr(0, len);
      }
      this.msg = this.msg.replace(new RegExp(this.keyword, 'ig'), "<span style=\"color:red\">"+this.keyword+"</span>");
      this.title = this.title.replace(new RegExp(this.keyword, 'ig'), "<span style=\"color:red\">"+this.keyword+"</span>");
      var allUrl = window.location.href;
      var urlItem = allUrl.split('/');
      var newUrl = urlItem[0]+'//'+urlItem[2];
      newUrl += this.$router.history.base;
      var tourl = '';
      if((this.$request.themeAction[this.item['theme']] != '')){
        tourl += '/' + (this.$request.themeAction[this.item['theme']]);
        newUrl += '/' + (this.$request.themeAction[this.item['theme']]);
      }
      if((this.$request.articleType[this.item['type']] != '')){
        tourl +='/' + (this.$request.articleType[this.item['type']]);
        newUrl += '/' + (this.$request.articleType[this.item['type']]);
      }
      tourl += "/detail?id="+this.item.id;
      newUrl += "/detail?id="+this.item.id;
      this.tourl = tourl;
      this.url = newUrl;
    },
    goDetail (url){
      this.$router.push(url)
    }
  },
  mounted() {
    this.title = this.item.title;
    this.msg = this.item.detail;
    this.dealMsg();
  },
  updated() {
  },
  watch:{
    item:{
      deep:true,
      handler:function (n,o) {
        this.title = this.item.title;
        this.msg = this.item.detail;
        this.dealMsg();
      }
    }
  },
}
</script>

<style scoped>
  .cred{color: #ff0000;}
  .cgreen{color: #638706;}
  .cgreen:hover{text-decoration: underline;}
  .cblue{color: #063674;}
  .scont .int{max-height: 80px;}
  .scont .sdiv{margin-bottom: 80px;}
</style>



// WEBPACK FOOTER //
// src/components/index/search-item.vue